window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.js-scroll-to', (e) => {
    e.preventDefault();
    const id = e.currentTarget.href;
    document.querySelector(id).scrollIntoView({
      behavior: 'smooth'
    });
  })
  if (!customElements.get('custom-slider')) {
    class CustomSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = new Swiper(this.querySelector('.js-custom-slider'), {
          slidesPerView: this.dataset.slidesMobile || 2,
          centeredSlides: this.dataset.centeredSlidesMobile || false,
          centeredSlidesBounds: true,
          spaceBetween: this.dataset.gap || 0,
          breakpoints: {
            991: {
              slidesPerView: this.dataset.slidesDesktop || 5,
              centeredSlides: this.dataset.centeredSlidesDesktop || false,
            }
          },
          on: {
            init: (e) => {
              this.classList.add('loaded')
            }
          },
          navigation: {
            enabled: true,

          },
          pagination: {
            enabled: true,
            clickable: true,
            el: this.querySelector('.js-pagination')
          }
        });
        
        console.log("SLIDER");
        this.querySelectorAll('.js-slide-next').forEach((btn) => {
          console.log(btn);
          btn.addEventListener('click', () => this.swiper.slideNext());
        })
        this.querySelectorAll('.js-slide-prev').forEach((btn) => {
          btn.addEventListener('click', () => this.swiper.slidePrev());
        })
      }
      update() {
        this.swiper.update();
      }
    }
    
    customElements.define('custom-slider', CustomSlider);
  }


})